module.exports = __webpack_public_path__ + "img/air_meter.dc9294e8.svg";